import GrComponentFactory from "../../../gr_component_factory";

export default GrComponentFactory.createClass({
  displayName: "SpoilerWarning",

  propTypes: {
    spoilerType: React.PropTypes.string.isRequired,
  },

  render() {
    return (
      <span className="authorAnswerNewsfeedItem__spoilerWarning">
        This {this.props.spoilerType} contains spoilers…
      </span>
    );
  },
});
